import { useEffect, useState } from "react";
import { clearViewAsToken, getViewAsToken, setViewAsToken } from "../api/client";

/**
 * VER COMO — soporte del superusuario con los ojos del usuario.
 *
 * El panel admin abre `/ver-como#t=<token>` en una pestaña nueva: el token
 * viaja en el HASH (nunca llega al server ni a los logs) y se guarda en el
 * sessionStorage de ESTA pestaña — la del panel sigue siendo del admin.
 * Después se recarga entero a /jugador: con el reload, AuthContext y todo lo
 * demás nacen ya como el usuario mirado, sin estados a medio camino.
 *
 * La sesión es de SOLO LECTURA (el backend corta toda escritura del token) y
 * vence sola a los 15 minutos, así navegar como él no le pisa el contexto
 * activo ni le manda nada. El banner de abajo lo deja siempre a la vista.
 */
export function VerComoEntrada() {
  useEffect(() => {
    const hash = new URLSearchParams(window.location.hash.slice(1));
    const token = hash.get("t");
    if (token) {
      try {
        setViewAsToken(token);
      } catch {
        // Sin sessionStorage (modo privado raro): no hay ver-como posible.
      }
    }
    window.location.replace("/jugador");
  }, []);
  return null;
}

/**
 * Banner fijo mientras la pestaña está en modo VER COMO. Colores sólidos a
 * propósito (ámbar sobre negro): tiene que gritar lo mismo en claro y en
 * oscuro, y no parecerse a nada de la app.
 */
export function VerComoBanner() {
  const [activo] = useState(() => Boolean(getViewAsToken()));
  const [vencida, setVencida] = useState(false);

  useEffect(() => {
    const onVencida = () => setVencida(true);
    window.addEventListener("forja:view-as-expired", onVencida);
    return () => window.removeEventListener("forja:view-as-expired", onVencida);
  }, []);

  if (!activo) return null;

  const salir = () => {
    clearViewAsToken();
    window.close();
    // Si el navegador no deja cerrar la pestaña (no la abrió un script en
    // algunos casos), volvemos al panel como el admin que sigue en localStorage.
    setTimeout(() => window.location.replace("/admin"), 150);
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "0.75rem",
        padding: "0.35rem 0.75rem",
        background: "#f59e0b",
        color: "#111827",
        fontSize: "0.8rem",
        fontWeight: 700,
      }}
    >
      <span>
        👁 VER COMO — sólo lectura{vencida ? " · VENCIÓ, cerrá esta pestaña" : " · vence a los 15 min"}
      </span>
      <button
        type="button"
        onClick={salir}
        style={{
          border: "1.5px solid #111827",
          borderRadius: "0.5rem",
          padding: "0.1rem 0.6rem",
          background: "transparent",
          color: "#111827",
          fontWeight: 800,
          cursor: "pointer",
        }}
      >
        Salir
      </button>
    </div>
  );
}
